// -------------------------------
// BUDGET INTERFACES
// -------------------------------
export interface PendingBudget {
    budgetTitle?: string;
    budgetType?: "project" | "category";
    project_id?: number;
    category_id?: number;
    startDate?: string;
    endDate?: string;
    overallRevenue?: string;
    overallExpense?: string;
    tax?: string;
    status?: string;
}

export interface PendingDeleteBudget {
    awaitingName?: boolean;
}
export const startCreateBudgetFlow = (
    setPending: (data: PendingBudget | null) => void,
    pushAIChat: (msg: string) => void,
    speak: (msg: string) => void,
    nameFromIntent?: string
) => {
    if (nameFromIntent) {
        setPending({ budgetTitle: nameFromIntent });
        pushAIChat("Is this budget for a project or a category?");
        speak("Is this budget for a project or a category?");
        return;
    }

    setPending({});
    pushAIChat("What is the budget title?");
    speak("What is the budget title?");
};
export const processPendingBudget = (
    text: string,
    pending: PendingBudget,
    setPending: (data: PendingBudget | null) => void,
    pushAIChat: (msg: string) => void,
    speak: (msg: string) => void
) => {

    // 1️⃣ Budget Title
    if (!pending.budgetTitle) {
        setPending({ ...pending, budgetTitle: text.trim() });
        pushAIChat("Is this budget for a project or a category?");
        speak("Is this budget for a project or a category.");
        return;
    }

    // 2️⃣ Budget Type
    if (!pending.budgetType) {
        const type = text.toLowerCase();
        if (type.includes("project")) {
            setPending({ ...pending, budgetType: "project" });

            pushAIChat("Please select a project.");
            speak("Please select a project.");

            window.dispatchEvent(
                new CustomEvent("ai-suggest-options", {
                    detail: { type: "budget-project" }
                })
            );
            return;
        }

        if (type.includes("category")) {
            setPending({ ...pending, budgetType: "category" });

            pushAIChat("Please select a category.");
            speak("Please select a category.");

            window.dispatchEvent(
                new CustomEvent("ai-suggest-options", {
                    detail: { type: "budget-category" }
                })
            );
            return;
        }

        pushAIChat("Please say project or category.");
        speak("Please say project or category.");
        return;
    }

    // 3️⃣ Project / Category selected via suggestion
    if (pending.budgetType === "project" && !pending.project_id) return;
    if (pending.budgetType === "category" && !pending.category_id) return;

    // 4️⃣ Start Date
    if (!pending.startDate) {
        setPending({ ...pending, startDate: text });
        pushAIChat("Please provide end date.");
        speak("Please provide end date.");
        return;
    }

    // 5️⃣ End Date
    if (!pending.endDate) {
        setPending({ ...pending, endDate: text });
        pushAIChat("What is the overall revenue?");
        speak("What is the overall revenue?");
        return;
    }

    // 6️⃣ Revenue
    if (!pending.overallRevenue) {
        setPending({ ...pending, overallRevenue: text.replace(/[^0-9.]/g, "") });
        pushAIChat("What is the overall expense?");
        speak("What is the overall expense?");
        return;
    }

    // 7️⃣ Expense
    if (!pending.overallExpense) {
        setPending({ ...pending, overallExpense: text.replace(/[^0-9.]/g, "") });
        pushAIChat("What is the tax amount?");
        speak("What is the tax amount?");
        return;
    }

    // 8️⃣ Tax → FINAL
    if (!pending.tax) {
        const finalData = {
            ...pending,
            tax: text.replace(/[^0-9.]/g, ""),
            status: "active",
        };

        pushAIChat(`Creating budget "${pending.budgetTitle}"...`);
        speak(`Creating budget ${pending.budgetTitle}.`);

        window.dispatchEvent(
            new CustomEvent("ai-create-budget", {
                detail: finalData
            })
        );

        setPending(null);
    }
};
export const startDeleteBudgetFlow = (
    setPendingDelete: (data: PendingDeleteBudget | null) => void,
    pushAIChat: (msg: string) => void,
    speak: (msg: string) => void,
    nameFromIntent?: string
) => {
    if (nameFromIntent) {
        window.dispatchEvent(
            new CustomEvent("ai-delete-budget", {
                detail: { name: nameFromIntent }
            })
        );
        return;
    }

    setPendingDelete({ awaitingName: true });
    pushAIChat("Which budget would you like to delete?");
    speak("Which budget would you like to delete?");
};
export const processPendingDeleteBudget = (
    text: string,
    pending: PendingDeleteBudget,
    setPendingDelete: (data: PendingDeleteBudget | null) => void,
    pushAIChat: (msg: string) => void,
    speak: (msg: string) => void
) => {
    if (!pending.awaitingName) return;

    const name = text.trim();
    if (!name) return;

    window.dispatchEvent(
        new CustomEvent("ai-delete-budget", {
            detail: { name }
        })
    );

    setPendingDelete(null);
};
